export default [
  {
    path: '/admin/access/unit/unit-index',
    name: 'M020025',
    component: () => import('@/views/admin/access/unit/UnitIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/access/application-system/system-index',
    name: 'M020026',
    component: () =>
      import('@/views/admin/access/application-system/SystemIndex.vue'),
    meta: { layout: 'admin' },
  },
];
